import React, {useCallback, useState} from 'react';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {convertDateForDisplay} from 'common/utils';
import {
  FileTransferUtils,
  convertFileSize,
  withAttachmentApi,
} from 'go/components/common/attachments/uploader/utils';
import ApiActions from 'go/actions/api';
import DynamicSearchableTable from 'componentLibrary/layout/dynamicSearchableTable';
import REST from 'go/requests/rest';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';

function downloadAttachmentLink(resourceId, fileName) {
  const downloadUrl = REST.attachment.getAttachmentDownloadUrl(resourceId);
  return (
    <a href={downloadUrl} title={`Download ${fileName}`}>
      {fileName}
    </a>
  );
}

const FileDescription = ({
  file: inputFile,
  index,
  updateDescription,
  token,
  ...otherProps
}) => {
  const [file, setFile] = useState(inputFile);

  return (
    <FemaGoTable.InputCell
      value={file.description}
      maxLength={501}
      id={file.fileName + index + '.description'}
      name="description"
      handleChange={(e, res) => {
        setFile({...file, description: res.value});
      }}
      handleBlur={() => {
        updateDescription(token, FileTransferUtils.createPayload(file));
      }}
      {...otherProps}
    />
  );
};

const textCell = (text) => (props) => (
  <FemaGoTable.TextCell {...props}>{text}</FemaGoTable.TextCell>
);

const rowComponents = ({
  file,
  fileSizeLimit,
  updateDescription,
  index,
  token,
  readOnly,
}) => {
  const {fileName, fileSize, uploadedDate, resourceId, description} = file;
  return {
    fileName: textCell(downloadAttachmentLink(resourceId, fileName)),
    uploadedDate: textCell(convertDateForDisplay(new Date(uploadedDate), true)),
    fileSize: textCell(convertFileSize(fileSize, fileSizeLimit)),

    description: !readOnly
      ? (props) => (
          <FileDescription
            file={file}
            index={index}
            updateDescription={updateDescription}
            token={token}
            {...props}
          />
        )
      : textCell(description),
  };
};

const ReviewAttachmentsSearchableTable = (props) => {
  const {token, fileSizeLimit, updateDescription, readOnly} = props;

  const dynamicRowContent = useCallback(
    (file, index) => {
      return rowComponents({
        file,
        fileSizeLimit,
        updateDescription,
        index,
        token,
        readOnly,
      });
    },
    [token, fileSizeLimit, updateDescription]
  );

  return <DynamicSearchableTable fnDynamicRowContent={dynamicRowContent} {...props} />;
};

export const mapStateToProps = (state) => ({
  token: _.get(state, 'auth.token'),
});

export const mapDispatchToProps = (dispatch) => ({
  updateDescription: (token, payload) => {
    const action = ApiActions.attachments.updateDescription(token, payload);
    const response = dispatch(action);
    return response;
  },
});

export default compose(
  connectDynamic,
  withAttachmentApi,
  connect(mapStateToProps, mapDispatchToProps)
)(ReviewAttachmentsSearchableTable);
